import { Box, Button, makeStyles, Typography } from '@material-ui/core'
import axios from 'axios'
import moment from 'moment'
import React, { useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import formatVehicleLabel from './formatVehicleLabel'
import useReservationClock, { canCancelReservation } from './reservationLifecycle'

const useStyles = makeStyles((theme) => ({
  error: { marginTop: theme.spacing(2) },
  cancelButton: { color: theme.palette.error.main, borderColor: theme.palette.error.main },
  footer: { '& .MuiButton-root.Mui-disabled': { opacity: 0.5 } }
}))

const CancelReservationModal = ({ reservation, onClose, onCancelled }) => {
  const classes = useStyles()
  const busyRef = useRef(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const now = useReservationClock([reservation])
  const canCancel = canCancelReservation(reservation, now)

  const cancelReservation = async () => {
    if (busyRef.current) return
    if (!canCancelReservation(reservation)) return
    busyRef.current = true
    setBusy(true)
    setError('')
    let cancelled
    try {
      const { data } = await axios.post(`vehicle-reservations/${reservation._id}/cancel`)
      if (!data.success || !data.data) setError(data.message || 'Rezervimi nuk u anulua. Provoni përsëri.')
      else cancelled = data.data
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Rezervimi nuk u anulua. Provoni përsëri.')
    } finally {
      busyRef.current = false
      setBusy(false)
    }
    if (cancelled) onCancelled(cancelled)
  }

  return (
    <Modal
      show
      className='modal-1'
      aria-labelledby='cancel-reservation-title'
      onHide={() => {
        if (!busyRef.current) onClose()
      }}
      backdrop={busy ? 'static' : true}
      keyboard={!busy}
    >
      <Modal.Header closeButton={!busy}>
        <Modal.Title id='cancel-reservation-title'>Anulo rezervimin</Modal.Title>
      </Modal.Header>
      <Modal.Body aria-busy={busy}>
        <Typography gutterBottom>A dëshironi ta anuloni këtë rezervim?</Typography>
        <Typography variant='body1'>
          {reservation.destination} — {moment(reservation.departureDate).format('DD/MM/YYYY')}, {reservation.departureTime}
        </Typography>
        <Typography variant='body2' gutterBottom>
          {reservation.vehicles.map(formatVehicleLabel).join(', ')}
        </Typography>
        <Typography variant='body2' color='textSecondary'>
          {reservation.status === 'approved'
            ? 'Rezervimi do të anulohet për të gjithë pjesëmarrësit dhe automjetet do të lirohen për rezervime të tjera.'
            : 'Kërkesa do të anulohet për të gjithë pjesëmarrësit.'}
        </Typography>
        {error && (
          <Box className={classes.error}>
            <Typography role='alert' color='error'>
              {error}
            </Typography>
          </Box>
        )}
        {!canCancel && (
          <Typography role='alert' color='error'>
            Rezervimi nuk mund të anulohet pasi të ketë kaluar ora e nisjes.
          </Typography>
        )}
      </Modal.Body>
      <Modal.Footer className={classes.footer}>
        <Button onClick={onClose} disabled={busy}>
          Kthehu
        </Button>
        <Button onClick={cancelReservation} variant='outlined' className={classes.cancelButton} disabled={busy || !canCancel}>
          {busy ? 'Duke anuluar…' : 'Anulo rezervimin'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CancelReservationModal
